// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pagination {\n  margin: 0;\n}\n.pagination-wrapper {\n  overflow: auto;\n  margin-left: auto;\n}", "",{"version":3,"sources":["webpack://src/components/Pagination/_pagination.scss"],"names":[],"mappings":"AAAA;EACI,SAAA;AACJ;AACI;EACI,cAAA;EACA,iBAAA;AACR","sourcesContent":[".pagination {\n    margin: 0;\n    \n    &-wrapper{\n        overflow: auto;\n        margin-left: auto;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
